import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { FaSpinner } from "react-icons/fa6";
import { AuthContext } from "../../context/AuthContext";

import "./Login.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  //   const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     setError("");

  //     try {
  //       //   const response = await axios.post(`${BASE_URL}/api/auth/login`, {
  //       //     username,
  //       //     password,
  //       //   });
  //       const response = await axios.post(
  //         "http://localhost:8000/api/auth/login",
  //         {
  //           username,
  //           password,
  //         }
  //       );

  //       if (response.data.success) {
  //         localStorage.setItem("authToken", response.data.token);
  //         localStorage.setItem("username", response.data.username);

  //         navigate("/dashboard");
  //       } else {
  //         setError("Invalid credentials");
  //       }
  //     } catch (err) {
  //       setError("Login failed. Please try again.");
  //       console.error(err);
  //     }
  //   };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/api/auth/login`, {
        username,
        password,
      });

      if (response.data.success) {
        login(response.data.token, response.data.username);
        // navigate("/dashboard");
        navigate("/testpage");
      } else {
        setError("Invalid credentials");
        setLoading(false);
      }
    } catch (err) {
      setError("Login failed. Please try again.");
      setLoading(false);
      console.error(err);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Admin Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {/* <button type="submit">
            {loading ? <FaSpinner style={{ textAlign: "center" }} /> : "Login"}
          </button> */}
          <button
            type="submit"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {loading ? (
              <>
                <FaSpinner className="spinner" />
                <span style={{ marginLeft: "8px" }}>Loading...</span>
              </>
            ) : (
              "Login"
            )}
          </button>
        </form>
        {error && <p className="error-text">{error}</p>}
      </div>
    </div>
  );
}

export default Login;
